
import { defineComponent } from "vue";
import LRecoveryForm from "@/components/form/LRecoveryForm.vue";

export default defineComponent({
  name: "Recovery",
  components: { LRecoveryForm },
});
